import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { authApi } from "../../services/api";
import logo from "../../images/developer_02.png";
import "../../css/admin.css";

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const justRegistered = (location.state as { registered?: boolean })?.registered;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    const newFieldErrors: Record<string, string> = {};
    if (!email.trim()) newFieldErrors.email = "Email is required";
    if (!password) newFieldErrors.password = "Password is required";
    setFieldErrors(newFieldErrors);
    if (Object.keys(newFieldErrors).length > 0) return;

    setLoading(true);

    try {
      const response = await authApi.login({ email, password });

      if (response.success && response.data?.token) {
        login(response.data.token);
        navigate("/admin/dashboard");
      } else {
        setError(response.message || "Invalid credentials");
      }
    } catch {
      setError("Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <img src={logo} alt="Logo" />
          <h1>Admin Panel</h1>
          <p>Sign in to manage your portfolio</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label className="admin-form-label">Email</label>
            <input
              type="email"
              className={`admin-form-input${fieldErrors.email ? " admin-input-error" : ""}`}
              placeholder="Enter your email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setFieldErrors((prev) => ({ ...prev, email: "" })); }}
              autoFocus
            />
            {fieldErrors.email && <span className="admin-field-error">{fieldErrors.email}</span>}
          </div>

          <div className="admin-form-group">
            <label className="admin-form-label">Password</label>
            <input
              type="password"
              className={`admin-form-input${fieldErrors.password ? " admin-input-error" : ""}`}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setFieldErrors((prev) => ({ ...prev, password: "" })); }}
            />
            {fieldErrors.password && <span className="admin-field-error">{fieldErrors.password}</span>}
          </div>

          {justRegistered && (
            <p className="admin-form-success">Account created! Sign in below.</p>
          )}

          {error && <p className="admin-form-error">{error}</p>}

          <button
            type="submit"
            className="admin-btn admin-btn-primary admin-btn-full"
            disabled={loading}
            style={{ marginTop: "1.5rem" }}
          >
            {loading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" />
                <span>Signing in...</span>
              </>
            ) : (
              <>
                <i className="fa-solid fa-right-to-bracket" />
                <span>Sign In</span>
              </>
            )}
          </button>
          <p className="admin-register-link">
            Don't have an account?{" "}
            <Link to="/admin/register">Register</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
